import makeStyles from '@material-ui/core/styles/makeStyles';
import { lighten, darken, alpha } from '@material-ui/core';

import { useColumnGroups, useColumns } from '../ColumnContext';
import HeaderCell from './HeaderCell';
import GroupHeader from './GroupHeader';
import { useContentWidth } from './RenderContext';

const useStyles = makeStyles((theme) => ({
    root: {
        borderStyle: 'solid',
        borderWidth: '1px 0',
        borderColor:
            theme.palette.type === 'light'
                ? lighten(alpha(theme.palette.divider, 1), 0.88)
                : darken(alpha(theme.palette.divider, 1), 0.68),
    },

    headerContainer: {
        position: 'relative',
        display: 'block',
        overflowX: 'hidden',
        overflowY: 'hidden',
        border: 'none',
        lineHeight: 0,
    },
}));

export default function Headers(props) {
    const { scrollerRef } = props;
    const columns = useColumns();
    const contentWidth = useContentWidth();
    const classes = useStyles();
    const groups = useColumnGroups(columns);

    return (
        <div className={classes.root}>
            <div ref={scrollerRef} className={classes.headerContainer} style={{ width: `${contentWidth}px` }}>
                <div>
                    {groups.map((group) => (
                        <GroupHeader key={group.id} group={group} />
                    ))}
                </div>
                <div>
                    {columns.map((column, index) => (
                        <HeaderCell
                            key={column.id}
                            column={column}
                            tooltip={column.getHeaderTooltip(column)}
                            lastColumn={index === columns.length - 1}
                        >
                            {column.headerRenderer(column)}
                        </HeaderCell>
                    ))}
                </div>
            </div>
        </div>
    );
}
